export const OPEN_CREATE_GROUP_DIALOG = 'OPEN_CREATE_GROUP_DIALOG';
export const CLOSE_CREATE_GROUP_DIALOG = 'CLOSE_CREATE_GROUP_DIALOG';

export const openCreateGroupDialog = initialFormData => ({
  type: OPEN_CREATE_GROUP_DIALOG,
  payload: initialFormData,
});

export const closeCreateGroupDialog = () => ({
  type: CLOSE_CREATE_GROUP_DIALOG,
});
